import { useState } from 'react';

import voca from 'voca';

const defaultValues = { isFallback: false, validationErrors: {} };

export default function useRequestError() {
  const [values, setValues] = useState(defaultValues);

  const handleValidationErrors = function (errors) {
    setValues({
      isFallback: false,
      validationErrors: parseValidationErrors(errors),
    });
  };

  const removeErrorStyling = (event) => {
    if (!values.validationErrors[event.target.name]) {
      return true;
    }

    const field = event.target.name;
    const { error } = values.validationErrors[field];
    const validationErrors = { ...values.validationErrors };

    validationErrors[field] = { error, fieldHighlighted: false };
    setValues({ ...values, validationErrors });
  };

  const resetRequestError = () => {
    setValues(defaultValues);
  };

  const handleRequestError = (error) => {
    switch (error.response?.status) {
      case 422:
        if (error.response.data.errors) {
          handleValidationErrors(error.response.data.errors);
        }
        break;
      default:
        setValues({ isFallback: true, validationErrors: {} });
    }
  };

  const validationErrors = Object.values(values.validationErrors);

  const isSubmitDisabled =
    validationErrors.length > 0 &&
    validationErrors.every(
      (validationError) => validationError.fieldHighlighted,
    );

  return [
    values,
    isSubmitDisabled,
    removeErrorStyling,
    resetRequestError,
    handleRequestError,
  ];
}

export const parseValidationErrors = (errors) => {
  const validationErrors = errors.reduce((map, error) => {
    if (error.source) {
      const key = voca.camelCase(error.source.attribute);
      map[key] = { error, fieldHighlighted: true };
    }

    return map;
  }, {});

  return validationErrors;
};
